module.exports = __webpack_public_path__ + "img/icon_jczc.f25fb98a.png";